import React from 'react'

import { BudgetingTag } from './BudgetingTag'

interface CostTypeHierarchyDisplayProps {
  hierarchy: string[]
}

export const CostTypeHierarchyDisplay: React.FC<
  CostTypeHierarchyDisplayProps
> = ({ hierarchy }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        flexWrap: 'wrap',
      }}>
      {hierarchy.map((level, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span style={{ color: '#888' }}>&gt;</span>}
          <BudgetingTag>{level}</BudgetingTag>
        </React.Fragment>
      ))}
    </div>
  )
}
